<template>
  <b-modal ref="modal" :title="$t('add-service')" size="xl" @ok="okClicked">
    <service-picker v-model="form.serviceId" :services="services" />
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ServicePicker from '@/components/inputs/ServicePicker.vue';

export default {
  name: 'AddServiceModal',
  props: {
    scene: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        serviceId: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'getServices',
    ]),
    services() {
      if (this.scene.services.length > 0) {
        return this.getServices.filter(
          service => !this.$_.includes(this.scene.services, service.id),
        );
      }
      return this.getServices;
    },
  },
  methods: {
    okClicked() {
      this.$emit('service-picked', this.form.serviceId);
      this.form.serviceId = null;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  components: {
    ServicePicker,
  },
};
</script>

<style scoped>

</style>
